import { FaStar } from 'react-icons/fa';

import { IconUser, IconPersonMoney, IconCompany, IconIdeasFeedback, IconGift } from 'assets/icons';
import { routePaths } from 'global/routePaths';

const AvatarMenuData = [
  {
    icon: IconUser,
    label: 'common:profile',
    path: routePaths.profile,
  },
  {
    icon: IconPersonMoney,
    label: 'common:account&Billing',
    path: routePaths.accountBilling.base.route,
    access: routePaths.accountBilling.base.access,
  },
  {
    icon: IconCompany,
    label: 'common:companySettings',
    path: routePaths.companySettings.base.route,
    access: routePaths.companySettings.base.access,
  },
  {
    icon: FaStar,
    label: 'common:productUpdates',
    path: 'https://help.timeero.com/product-updates',
    nativeLink: true,
    newTab: true,
  },
  { icon: IconIdeasFeedback, label: 'common:ideas&Feedback', path: 'https://timeero.roadmap.space/', nativeLink: true },
  { icon: IconGift, label: 'common:referAndEarn', path: routePaths.referAndEarn, belowScreenSize1280: true },
  { label: 'common:helpCenter', path: 'https://help.timeero.com', nativeLink: true, belowScreenSize1280: true },
];

export default AvatarMenuData;
